import {Injectable} from '@angular/core';
import {Headers, Http, Response} from '@angular/http';
import 'rxjs/add/operator/toPromise';
import {webapi,CONSTQUESTWELLHOSPITAL} from '../../shared/my-constants';

@Injectable()
export class MbillTariffService {
  mbillTariff: any;
  private headers = new Headers({'Content-Type': 'application/json'});
  private ListRecord = webapi + 'mbill_tariff/list/?';
  private ListRecordForSelect = webapi + 'mbill_tariff/listforselect';
  private ListTariff = webapi + 'mbill_tariff/listtariff';
  private AddRecord = webapi + 'mbill_tariff/create';
  private EditRecord = webapi + 'mbill_tariff/update';
  private EditserviceRecord = webapi + 'mbill_tariff/updateservice';
  private GetRecord = webapi + 'mbill_tariff/byid/';
  private DeleteRecord = webapi + 'mbill_tariff/delete/';
  private DeleteServiceRecord = webapi + 'mbill_tariff/deleteservice/';
  private AddTarrifServiceRecord = webapi + 'mbill_tariff_service/create';
  private ListRecordByUnitId = webapi + 'mbill_tariff/listByUnitId/?';
  private listServicesByTariff = webapi + 'mbill_tariff/listservicebytariff?';
  private listservicebytariffid = webapi + 'mbill_tariff/listservicebytariffid?';
  private listservicebytariffidserviceId = webapi + 'mbill_tariff/listservicebytariffidserviceid?';
  private listservicebytariffidservice = webapi + 'mbill_tariff/listservicebytariffidservice?';
  private listservicebytariffidsgIdservice = webapi + 'mbill_tariff/listservicebytariffidsgIdservice/';
  private ListTarrifServiceRecord = webapi + 'mbill_tariff_service/list/?';
  private ListTarrifServiceRecordBySubGroupId = webapi + 'mbill_tariff_service/listbysubgroup/?';
  private GetRecordByGenderId = webapi + 'mbill_tariff/listtariffbygender/?';
  private GetCompanyName = webapi + 'mbill_tariff/listcompanyname/?';

  private GetRecordByGenderIdAndTariffId = webapi + 'mbill_tariff/listtariffbygenderandtarifftype/?';

  private GetRecordByGenderIdage = webapi + 'mbill_tariff/listtariffbygenderandgae/?';

  private GetRecordByGenderIdageAndTariifType = webapi + 'mbill_tariff/listtariffbygenderandgaeandtarifftype/?';

  private ListTariffByUnitId = webapi + 'mbill_tariff/listtariffByUnitId?';
  private listservicebytariffidByPagination = webapi + 'mbill_tariff/listservicebytariffidByPagination?';
  private listservicebyispackageservice = webapi + 'mbill_tariff/listservicebyispackageservice/?';
  private ServiceByTariffIdAndServiceId = webapi + 'mbill_tariff/getServiceByTariffIdAndServiceId?';

  constructor(private http: Http) {
  }
    getAllRecordService(currentPage: any, size: any, qString: any, sort: any, col: any): Promise<any> {
    return this.http.get(this.ListRecord + 'page=' + currentPage + '&size=' + size + '&qString=' + qString + '&sort=' + sort + '&col=' + col)
      .toPromise()
      .then(response => response.json())
      .catch(this.handleError);
  }

  getAllRecordServiceByUnitId(currentPage: any, size: any, qString: any, sort: any, col: any, unitId: any): Promise<any> {
    return this.http.get(this.ListRecordByUnitId + 'page=' + currentPage + '&size=' + size + '&qString=' + qString + '&sort=' + sort + '&col=' + col + '&unitId=' + unitId)
      .toPromise()
      .then(response => response.json())
      .catch(this.handleError);
  }

  getAllRecordForSelect(): Promise<any> {
    return this.http.get(this.ListRecordForSelect)
      .toPromise()
      .then(response => response.json())
      .catch(this.handleError);
  }

  getAllServicesbyTariff(tariffId: any) {
    return this.http.get(this.listServicesByTariff + 'tariffId=' + tariffId)
      .toPromise()
      .then(response => response.json())
      .catch(this.handleError);
  }

  getAllServicesbyTariffId(tariffId: any) {
    return this.http.get(this.listservicebytariffid + 'tariffId=' + tariffId)
      .toPromise()
      .then(response => response.json())
      .catch(this.handleError);
  }

  getAllServicesbyTariffIdByPagination(tariffId: any, currentPage: any, size: any) {
    return this.http.get(this.listservicebytariffidByPagination + 'tariffId=' + tariffId + '&page=' + currentPage + '&size=' + size)
      .toPromise()
      .then(response => response.json())
      .catch(this.handleError);
  }

  getAllServicesbyTariffIdserviceId(tariffId: any, serviceId: any) {
    return this.http.get(this.listservicebytariffidserviceId + 'tariffId=' + tariffId + '&serviceId=' + serviceId)
      .toPromise()
      .then(response => response.json())
      .catch(this.handleError);
  }

  // getAllServicesbyTariffIdservicename(tariffId: any, service: any) {
  //   return this.http.get(this.listservicebytariffidservice + 'tariffId=' + tariffId + '&service=' + service +'&isExtended=true')
  //     .toPromise()
  //     .then(response => response.json())
  //     .catch(this.handleError);
  // }
  getAllServicesbyTariffIdservicename(tariffId: any, service: any) {
    let url = this.listservicebytariffidservice + 'tariffId=' + tariffId + '&service=' + service;
    
    if (CONSTQUESTWELLHOSPITAL) {
      url += '&isExtended=true';
    }
  
    return this.http.get(url)
      .toPromise()
      .then(response => response.json())
      .catch(this.handleError);
  }

  getAllServicesbyTariffIdSubgroupIdservicename(tariffId: any, subGroupId: any, service: any) {
    return this.http.get(this.listservicebytariffidsgIdservice + tariffId + '/' + subGroupId + '/' + service)
      .toPromise()
      .then(response => response.json())
      .catch(this.handleError);
  }

  getAllRecordServiceForServiceTariif(currentPage: any, size: any, qString: any, sort: any, col: any): Promise<any> {
    return this.http.get(this.ListTarrifServiceRecord + 'page=' + currentPage + '&size=' + size + '&qString=' + qString + '&sort=' + sort + '&col=' + col)
      .toPromise()
      .then(response => response.json())
      .catch(this.handleError);
  }

  getAllRecordServiceForServiceTariifBySubGroupId(currentPage: any, size: any, qString: any, sort: any, col: any): Promise<any> {
    return this.http.get(this.ListTarrifServiceRecordBySubGroupId + 'page=' + currentPage + '&size=' + size + '&qString=' + qString + '&sort=' + sort + '&col=' + col)
      .toPromise()
      .then(response => response.json())
      .catch(this.handleError);
  }

  getTariffList() {
    return this.http.get(this.ListTariff)
      .toPromise()
      .then(response => response.json())
      .catch(this.handleError);
  }

  addRecordService(model: any) {
    return this.http.post(this.AddRecord, JSON.stringify(model), {headers: this.headers})
      .toPromise()
      .then(response => response.json())
      .catch(this.handleError);
  }

  addTariffServiceRecordService(model: any) {
    return this.http.post(this.AddTarrifServiceRecord, JSON.stringify(model), {headers: this.headers})
      .toPromise()
      .then(response => response.json())
      .catch(this.handleError);
  }

  editRecordService(model: any) {
    return this.http.put(this.EditRecord, JSON.stringify(model), {headers: this.headers})
      .toPromise()
      .then(response => response.json())
      .catch(this.handleError);
  }

  editRecordtariffService(model: any) {
      return this.http.put(this.EditserviceRecord, JSON.stringify(model), {headers: this.headers})
          .toPromise()
          .then(response => response.json())
          .catch(this.handleError);
  }

  deleteRecordService(id: any) {
    return this.http.put(this.DeleteRecord + id, {headers: this.headers})
      .toPromise()
      .then(response => response.json())
      .catch(this.handleError);
  }

    deleteserviceRecordService(id: any) {
        return this.http.put(this.DeleteServiceRecord + id, {headers: this.headers})
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

    getRecordService(id: any) {
    return this.http.get(this.GetRecord + id)
      .toPromise()
      .then(response => response.json())
      .catch(this.handleError);
  }

  getRecordbygenderService(id: any, unitid: any) {
    return this.http.get(this.GetRecordByGenderId + 'genderId=' + id + '&unitid=' + unitid)
      .toPromise()
      .then(response => response.json())
      .catch(this.handleError);
  }

  getCompanyName() {
    return this.http.get(this.GetCompanyName)
        .toPromise()
        .then(response => response.json())
        .catch(this.handleError);
  }

    getRecordbygenderServiceAndTariffType(id: any, unitid: any , tariffType: any) {
        return this.http.get(this.GetRecordByGenderIdAndTariffId + 'genderId=' + id + '&unitid=' + unitid + '&tariffType=' + tariffType)
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

  getRecordbygenderageService(genderid: any, age: any, unitid: any) {
    return this.http.get(this.GetRecordByGenderIdage + 'genderId=' + genderid + '&unitid=' + unitid + '&age=' + age)
      .toPromise()
      .then(response => response.json())
      .catch(this.handleError);
  }


    getRecordbygenderageAndTariffType(genderid: any, age: any, unitid: any , tariffType: any) {
        return this.http.get(this.GetRecordByGenderIdageAndTariifType + 'genderId=' + genderid + '&unitid=' + unitid + '&age=' + age + '&tariffType=' + tariffType)
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }


  getTariffListByUnitId(unitId: any) {
    return this.http.get(this.ListTariffByUnitId + 'unitId=' + unitId)
      .toPromise()
      .then(response => response.json())
      .catch(this.handleError);
  }

    getAllServicesByIsPackageServiceName(tariffId: any, service: any) {
    console.log(this.listservicebyispackageservice + 'tariffId=' + tariffId + '&service=' + service);
        return this.http.get(this.listservicebyispackageservice + 'tariffId=' + tariffId + '&service=' + service)
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }
    getServiceByTariffIdAndServiceId(tariffId: any, serviceId: any) {
        return this.http.get(this.ServiceByTariffIdAndServiceId + 'tariffId=' + tariffId + '&serviceId=' + serviceId)
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

  private handleError(error: Response | any) {
    return Promise.reject(error.message || error);
  }
}




// WEBPACK FOOTER //
// D:/CODE_REPOSITORIES/HIMS/HIMS_FRONTEND/src/app/configuration/mbill-tariff/mbill-tariff.service.ts